import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRankRocketBronze = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.1786 2.04984C14.861 0.827552 17.139 0.827554 18.8214 2.04984L28.3955 9.00588C30.0779 10.2282 30.7818 12.3947 30.1392 14.3724L26.4822 25.6276C25.8396 27.6053 23.9966 28.9443 21.9172 28.9443H10.0828C8.00335 28.9443 6.16037 27.6053 5.51777 25.6276L1.86076 14.3724C1.21817 12.3947 1.92213 10.2282 3.60447 9.00588L13.1786 2.04984Z",
			fill: "#EAAF90"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.6337 18.6767C14.15 18.2932 13.7118 17.8549 13.3282 17.3712C13.3383 17.3155 13.349 17.26 13.3602 17.2047C13.5929 16.0584 14.0707 15.0011 14.7365 14.0899C16.1915 12.0985 18.5446 10.8048 21.1998 10.8047C21.1998 13.46 19.9061 15.8133 17.9147 17.2685C17.0035 17.9343 15.9461 18.4122 14.7998 18.6449C14.7447 18.6561 14.6893 18.6667 14.6337 18.6767Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.9998 14.0047C12.2325 14.0047 10.7998 15.4374 10.7998 17.2047H13.3602C13.5929 16.0584 14.0707 15.0011 14.7365 14.0899C14.5 14.0342 14.2533 14.0047 13.9998 14.0047Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.7998 21.2047C16.5671 21.2047 17.9998 19.772 17.9998 18.0047C17.9998 17.7513 17.9704 17.5048 17.9147 17.2685C17.0035 17.9343 15.9461 18.4122 14.7998 18.6449V21.2047Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.9147 17.2685C17.9704 17.5048 17.9998 17.7513 17.9998 18.0047C17.9998 19.772 16.5671 21.2047 14.7998 21.2047V18.6449M17.9147 17.2685C19.9061 15.8133 21.1998 13.46 21.1998 10.8047C18.5446 10.8048 16.1915 12.0985 14.7365 14.0899M17.9147 17.2685C17.0035 17.9343 15.9461 18.4122 14.7998 18.6449M14.7365 14.0899C14.5 14.0342 14.2533 14.0047 13.9998 14.0047C12.2325 14.0047 10.7998 15.4374 10.7998 17.2047H13.3602M14.7365 14.0899C14.0707 15.0011 13.5929 16.0584 13.3602 17.2047M14.7998 18.6449C14.7447 18.6561 14.6893 18.6667 14.6337 18.6767C14.15 18.2932 13.7118 17.8549 13.3282 17.3712C13.3383 17.3155 13.349 17.26 13.3602 17.2047M12.1662 18.4798C11.5796 18.9173 11.1998 19.6166 11.1998 20.4047C11.1998 20.531 11.2096 20.6551 11.2284 20.7761C11.3494 20.7949 11.4735 20.8047 11.5998 20.8047C12.3878 20.8047 13.0872 20.4249 13.5247 19.8383",
			stroke: "white",
			strokeWidth: .8,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.4003 14.4016C18.4003 14.8434 18.0421 15.2016 17.6003 15.2016C17.1585 15.2016 16.8003 14.8434 16.8003 14.4016C16.8003 13.9597 17.1585 13.6016 17.6003 13.6016C18.0421 13.6016 18.4003 13.9597 18.4003 14.4016Z",
			fill: "white",
			stroke: "white",
			strokeWidth: .8,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgRankRocketBronze;
